import { InputConverterFunc } from '../../inputConverter';

export interface IExtentConfiguration {
    label?: string;
    toolTip?: string;
    icon: string;
    color?: string;
    extent: ExtentReturn;
    extentType?: ExtentType;
}

export default class ExtentConfiguration implements IExtentConfiguration {
    constructor(obj?: IExtentConfiguration) {
        Object.assign(this, obj);

        if (!this.extentType || (this.extentType !== 'static' && typeof this.extent !== 'function')) {
            throw new Error('extentType is invalid');
        }
    }

    label = 'Go To Extent';
    toolTip = 'Click to go to Extent';
    /** Calcite Icon Name or SVG Path */
    icon = '';
    color: IconColors = 'default';

    extent: ExtentReturn;
    extentType: ExtentType = 'static';

    get isSVG() { return this.icon.toLowerCase().startsWith('m') && this.icon.endsWith('z'); }
    get qualifiedIcon() { return this.isSVG ? null : this.icon.startsWith('icon-ui-') ? this.icon : `icon-ui-${this.icon}`; }
    get qualifiedIconColor() { return this.color === 'default' ? null : `icon-ui-${this.color}`; }
    get qualifiedSVGColor() { return this.color === 'default' ? null : `svg-icon-${this.color}`; }
}

export let ExtentConfigurationConverter: InputConverterFunc<ExtentConfiguration> = (value: any) => {
    if (typeof value === 'string') { return new ExtentConfiguration(<IExtentConfiguration>JSON.parse(value)); }
    if (typeof value === 'object') { return new ExtentConfiguration(<IExtentConfiguration>value); }
    return value;
};

export let ExtentConfigurationArrayConverter: InputConverterFunc<ExtentConfiguration[]> = (value: any) => {
    if (typeof value === 'string') { return (<IExtentConfiguration[]>JSON.parse(value)).map(c => new ExtentConfiguration(c)); }
    if (typeof value === 'object') { return (<IExtentConfiguration[]>value.map(c => new ExtentConfiguration(c))); }
    return value;
};

export type IconColors = 'default' | 'green' | 'light-blue' | 'blue' | 'dark-blue ' | 'purple' | 'orange' | 'gray' | 'red' | 'yellow';
export type ExtentReturn = __esri.Extent | __esri.ExtentProperties | number[] | ExtentReturnFunction | ExtentReturnAsyncFunction;
export type ExtentReturnFunction = (mapViewRef: __esri.MapView) => __esri.Extent | number[];
export type ExtentReturnAsyncFunction = (mapViewRef: __esri.MapView) => Promise<__esri.Extent | number[]>;
export type ExtentType = 'static' | 'func' | 'async-func';
